// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, hideElementOnPrint } from "@eisinc/XDL/Utilities";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

primaryImageStyles.wrapper = {
    css: css`
        display: flex;
        gap: 22px;
        flex-direction: row-reverse;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 12px;
        }
    `,
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            aspect-ratio: 1;
            margin: 0;

            > div {
                width: 100% !important;

                img {
                    aspect-ratio: 1;
                }
            }

            .enlarged-img {
                background-color: ${color("common.white")};
                z-index: 9;
            }

            &.has-error {
                & + ${IconWrapper} {
                    display: none;
                }
                img {
                    cursor: initial;
                }
            }
        `,
    },

    img: {
        css: css`
            aspect-ratio: 1;
            width: auto;
            object-fit: contain;
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    ...primaryImageStyles.fullPrimaryImage,
    img: {
        css: css`
            width: auto;
            max-height: 80vh;
        `,
    },
};

primaryImageStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
        flex: 1;
        aspect-ratio: 1;
        min-height: 543px;
        max-width: 543px;
        ${xScreen("lte", "md")} {
            min-height: 358px;
            max-width: 100%;
        }

        ${xScreen("lte", "sm")} {
            min-height: unset;
        }

        @media print {
            width: 300px;
            height: 300px;
            max-width: 300px;
            max-height: 300px;
        }
    `,
};
primaryImageStyles.magIcon = {
    size: 40,
    color: "primary.main",
    css: css`
        padding: 8px;
        background-color: transparent;
        position: absolute;
        right: 12px;
        bottom: 12px;
        cursor: pointer;
        z-index: 2;
        transition: all 0.3s ease-in-out;
        svg {
            height: 24px;
            width: 24px;
        }
        &:hover svg {
            color: ${color("common.ui8")};
        }
        ${hideElementOnPrint}
    `,
};

primaryImageStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        white-space: nowrap;
        overflow: hidden;
        border-radius: 2px;
        & > div {
            padding: 4px 6px;
            display: flex;
        }
    `,
};

primaryImageStyles.badgeText = {
    size: fontConfig.xxSmall.size,
    lineHeight: fontConfig.xxSmall.lineHeight,
};

primaryImageStyles.fullPrimaryImageModal = {
    mergeCss: true,
    size: 1230,
    cssOverrides: {
        modalTitle: css`
            &:after {
                display: none;
            }
            position: absolute;
            padding: 0;
            right: 16px;
            top: 16px;
            button,
            ${IconWrapper}, svg {
                width: 18px;
                height: 24px;
            }
        `,

        modalContent: css`
            padding: 0;
        `,
        modalBody: css`
            padding: 20px;
        `,
    },
};

primaryImageStyles.verticalCarousel = {
    mainContainer: {
        offsetCss: css`
            height: 100%;
            .swiper {
                height: 100%;
                .swiper-slide {
                    width: 92px;
                    height: 92px;
                }
            }
        `,
    },
};

primaryImageStyles.imageContainer = {
    css: css`
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        img {
            cursor: ${(props: any) => (props?.isImageAvailable ? "pointer" : "initial")} !important;
        }

        ${xScreen("lte", "lg")`
                height: auto;
            `}

        ${xScreen("lte", "sm")`
                height: 280px;
                
                img {
                    max-height: 100%;
                    max-width: 100%;
                    height: auto;
                    width: auto;
                }
            `}
          
          @media print {
            max-width: 300px;
            height: 300px;
        }
    `,
};
primaryImageStyles.modalImageContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    `,
};
